import { useEffect, useState } from "react";
import { Timer } from "lucide-react";
import { getChairsideTimer } from "../lib/chairsideStore";

/**
 * ChairsideTimer — thin overlay chip that displays elapsed time since the
 * timer was started for the case. Reads timer state from localStorage
 * so it survives page navigation across the mobile chairside workflow.
 *
 * Renders NOTHING when there's no running timer. Non-invasive.
 */
function _fmt(ms) {
  const s = Math.floor(ms / 1000);
  const mm = Math.floor(s / 60).toString().padStart(2, "0");
  const ss = (s % 60).toString().padStart(2, "0");
  if (s < 3600) return `${mm}:${ss}`;
  const hh = Math.floor(s / 3600).toString();
  return `${hh}:${mm}:${ss}`;
}

export default function ChairsideTimer({ caseId }) {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const iv = setInterval(() => setTick((n) => n + 1), 1000);
    return () => clearInterval(iv);
  }, []);

  const t = getChairsideTimer();
  if (!t) return null;
  // If a specific caseId is passed, only render for that case (avoids
  // showing a stale timer when the clinician navigates to a different case).
  if (caseId && t.case_id !== caseId) return null;

  const elapsed = Math.max(0, Date.now() - t.started_at);
  return (
    <div
      data-testid="chairside-timer"
      className="inline-flex items-center gap-1.5 text-[11px] font-mono px-2 py-1 rounded bg-[var(--pa-gold)]/15 border border-[var(--pa-gold)]/40 text-[var(--pa-gold)]"
      aria-label={`Chairside timer ${_fmt(elapsed)}`}
      // tick is read so React re-renders every second
      data-tick={tick}
    >
      <Timer size={11} /> <span data-testid="chairside-timer-elapsed">{_fmt(elapsed)}</span>
    </div>
  );
}
